/**
 * 购买记录展示：兼容 Unix 秒/毫秒、ISO 字符串；金额兼容多字段与「分/元」。
 */

export function parsePurchaseDate(val) {
  if (val == null || val === '') return null
  if (typeof val === 'number' && Number.isFinite(val)) {
    const ms = val < 1e12 ? val * 1000 : val
    const d = new Date(ms)
    return Number.isNaN(d.getTime()) ? null : d
  }
  const s = String(val).trim()
  if (!s) return null
  if (/^\d{10,13}$/.test(s)) {
    const n = Number(s)
    const ms = n < 1e12 ? n * 1000 : n
    const d = new Date(ms)
    return Number.isNaN(d.getTime()) ? null : d
  }
  // 明确按本地时间解析 `YYYY-MM-DDTHH:mm:ss` / `YYYY-MM-DD HH:mm:ss`，
  // 避免不同浏览器对 Date(string) 的时区处理差异导致 ±8 小时偏移。
  const normalized = s.replace(' ', 'T')
  const m = normalized.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/
  )
  if (m) {
    const tz = m[7]
    // 带时区信息：按真实时区解析（例如 UTC 的 paid_at 应转换为北京时间）
    if (tz) {
      const dTz = new Date(normalized)
      return Number.isNaN(dTz.getTime()) ? null : dTz
    }
    const y = Number(m[1])
    const mon = Number(m[2]) - 1
    const d = Number(m[3])
    const h = Number(m[4])
    const min = Number(m[5])
    const sec = Number(m[6] || 0)
    const localDate = new Date(y, mon, d, h, min, sec)
    return Number.isNaN(localDate.getTime()) ? null : localDate
  }

  const d = new Date(normalized)
  return Number.isNaN(d.getTime()) ? null : d
}

export function formatPurchaseDateTime(val) {
  const d = parsePurchaseDate(val)
  if (!d) return '---'
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const h = String(d.getHours()).padStart(2, '0')
  const min = String(d.getMinutes()).padStart(2, '0')
  const sec = String(d.getSeconds()).padStart(2, '0')
  return `${y}-${m}-${day} ${h}:${min}:${sec}`
}

function pickAmountRaw(p) {
  if (!p || typeof p !== 'object') return null
  const keys = [
    'amount_yuan',
    'pay_amount_yuan',
    'paid_amount_yuan',
    'actual_amount_yuan',
    'amount',
    'pay_amount',
    'paid_amount',
    'total_amount',
    'final_amount',
    'real_amount',
    'price',
    'total_fee'
  ]
  for (const k of keys) {
    const v = p[k]
    if (v != null && v !== '') return v
  }
  return null
}

/**
 * 展示为人民币元（两位小数）。整数按「分」换算；已是小数则按元。
 */
export function formatPurchaseYuan(p) {
  const raw = pickAmountRaw(p)
  if (raw == null || raw === '') return '0.00'
  const n = Number(raw)
  if (!Number.isFinite(n)) return '0.00'
  if (!Number.isInteger(n)) return n.toFixed(2)
  return (n / 100).toFixed(2)
}

export function pickPurchaseTimeField(p) {
  if (!p || typeof p !== 'object') return null
  const paid = p.paid_at ?? p.paidAt
  const status = Number(p.status)
  // 已支付订单：统一展示支付时间，不再回退到 created_at。
  if (status === 1) {
    if (paid == null || paid === '') return null
    const s = String(paid).trim()
    if (!s) return null
    // 后端 paid_at 当前为 UTC 语义但无时区标记（例如 2026-04-24T09:39:46），
    // 这里补 Z 让前端按 UTC 解析并转换为北京时间展示。
    const hasTz = /(Z|[+-]\d{2}:?\d{2})$/i.test(s)
    return hasTz ? s : `${s}Z`
  }
  return (
    paid ??
    p.pay_time ??
    p.payTime ??
    p.payment_time ??
    p.created_at ??
    p.create_time ??
    null
  )
}
